export const tokens = {
  colors: {
    background: {
      default: "rgba(255, 251, 254, 1)",
      surface: "rgba(255, 251, 254, 1)",
      elevated: "rgb(247, 243, 249)"
    },
    text: {
      primary: "rgba(28, 27, 31, 1)",
      secondary: "rgba(73, 69, 79, 1)",
      muted: "rgba(121, 116, 126, 1)",
      onPrimary: "rgba(255, 255, 255, 1)",
      onSecondary: "rgba(255, 255, 255, 1)"
    },
    accent: {
      primary: "rgba(103, 80, 164, 1)",
      secondary: "rgba(98, 91, 113, 1)",
      olive: "rgba(125, 82, 96, 1)"
    },
    border: "rgba(202, 196, 208, 1)",
    surfaceVariant: "rgba(231, 224, 236, 1)"
  },
  typography: {
    heading: '"Oswald", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    body: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif'
  },
  spacing: {
    sectionY: { xs: 6, md: 10 },
    sectionX: { xs: 2, md: 4 }
  },
  shadows: {
    soft: "0 8px 24px rgba(0, 0, 0, 0.35)"
  },
  radius: {
    base: 4,
    tight: 2,
    card: 6
  }
}
